module.exports = __webpack_public_path__ + "static/img/home_2.d83a26f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_2.png
// module id = jXkq
// module chunks = 0